import { ApprovedCharge as ServerApprovedCharge, ApprovedChargeOptions } from 'server/models/ApprovedCharge';
import { NumberOfUnits, TotalPriceForCharge } from 'data/models/Charge';
import { ImmutablePrice } from 'data/models/Price';
import { IQuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingWithDefaults } from 'data/models/QuickBooksInventoryItemTracking';

export { ApprovedChargeData, ApprovedChargeOptions } from 'server/models/ApprovedCharge';

export class ApprovedCharge extends ServerApprovedCharge {
    QBTracking : IQuickBooksInventoryItemTracking;
    Total : ImmutablePrice;

    constructor();
    constructor(data : ApprovedChargeOptions);
    constructor(data : ApprovedChargeOptions | null = null) {
        super(data || { Id: 0 });

        this.QBTracking = QuickBooksInventoryItemTrackingWithDefaults(this.QBTrackingOverrides, () => this.StandardItem() && this.StandardItem()!.QBTracking);
        this.Total = TotalPriceForCharge(this);
    }

    NumberOfUnits() {
        return NumberOfUnits(this);
    }
}


// WEBPACK FOOTER //
// ./data/models/ApprovedCharge.ts